<div class="rating-input-container" (mouseleave)="onMouseLeave()">
  @for (star of stars; track star) {
    <span
      class="star"
      [class.filled]="isStarFilled(star)"
      [class.disabled]="disabled"
      role="button"
      [attr.tabindex]="disabled ? -1 : 0"
      (click)="selectRating(star)"
      (keydown.enter)="selectRating(star)"
      (mouseenter)="onMouseEnter(star)"
    >
      ★
    </span>
  }
</div>
